export default (cep = "") => {
  const val = cep ? cep.replace(/\D/g, "") : "";
  return val.length === 8;
};
